import { render, staticRenderFns } from "./logisImportErrorListV0.vue?vue&type=template&id=f1ba5914&scoped=true"
import script from "./logisImportErrorListV0.vue?vue&type=script&lang=js"
export * from "./logisImportErrorListV0.vue?vue&type=script&lang=js"
import style0 from "./logisImportErrorListV0.vue?vue&type=style&index=0&id=f1ba5914&prod&lang=scss&scoped=true"
import style1 from "./logisImportErrorListV0.vue?vue&type=style&index=1&id=f1ba5914&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ba5914",
  null
  
)

export default component.exports